import React, { useEffect } from "react";
import { ArrowBack, ConstructSharp } from "react-ionicons";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import FContainer from "../../components/FContainer/FContainer";
import { useAgreements } from "../../hooks/useAgreements";
import {
  CheckmarkCircleOutline,
} from "react-ionicons";

const TermsAndConditions = ({ param }) => {
  const MySwal = withReactContent(Swal);

  const route = useNavigate();
  const { AcceptedAgreemenById, AcceptedAgreements, acceptAgreement, agreements } = useAgreements();


  useEffect(() => {
    AcceptedAgreements()
  }, []);

  useEffect(() => {
    console.log("agreements", agreements)
  }, [agreements]);

  const base64toBlob = (data) => {
    // Cut the prefix `data:application/pdf;base64` from the raw base 64
    const base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);

    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);

    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }

    return new Blob([out], { type: 'application/pdf' });
  };

  function downloadPDF(name, pdf) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = name + ".pdf";
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  return (
    <>
      <FContainer>
        <div className={`border-0 w-full grid grid-cols-1 ${agreements.length <= 1 ? "" : "xs:grid-cols-2 sm:grid-cols-4"}`}>
          {agreements.length <= 0 ? null :
            agreements.map((agreement) => (
              <div className="border-0 col-span-1 grid place-items-center text-large">
                <div className="border-0 absolute bg-green-700 rounded-full w-[35px] grid place-items-center p-[6px] mb-[175px] ml-[120px] shadow-2xl">
                  <CheckmarkCircleOutline
                    cssClasses={"!w-full !h-full !text-black !rounded-full mt-[1px] mr-[2px]"}
                  />
                </div>
                <div className="border-2 w-[120px] m-2 shadow-lg rounded-xl my-5">
                  <div className="border-0 m-2 rounded-xl bg-red-300 h-[80px] grid place-items-center cursor-pointer"
                    onClick={async () => {
                      let data = await AcceptedAgreemenById(agreement.documentTitle);
                      MySwal.fire({
                        showCloseButton: true,
                        showCancelButton: false,
                        showConfirmButton: false,
                        html: (
                          <MySwalViewPDF
                            url={data[1].content}
                          />
                        ),
                      });
                    }}
                  >
                    <img
                      className="w-[50px] h-[50px]"
                      src={require("../../components/assets/images/pdf.png")
                      }
                    />
                  </div>
                  <div className="border-0 grid place-items-center py-1 text-[11px] truncate text-center">
                    {agreement.agreement.type}
                  </div>
                  <div className="border-0 h-[50px] grid place-items-center py-1">
                    <div className="border-0 py-[5px] px-4 rounded-lg text-[13px] cursor-pointer bg-green-300 hover:bg-green-400"
                      onClick={async () => {
                        let data = await AcceptedAgreemenById(agreement.documentTitle);
                        downloadPDF(agreement.agreement.type, data[1].content)
                      }}
                    >Descargar</div>
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </FContainer>
    </>
  );
};


const MySwalViewPDF = ({ url }) => {
  return (
    <>
      <iframe
        className="w-full h-[400px] mt-6 rounded-3xl"
        name="nombre"
        src={'data:application/pdf;base64,' + url}
      ></iframe>
    </>
  );
};

export default TermsAndConditions;
